import { Request } from './Request';

export interface IRunVizRecommendationsTrainerParams {
}

export interface IRunVizRecommendationsTrainerResult {
}

export class RunVizRecommendationsTrainerRequest extends Request<IRunVizRecommendationsTrainerParams, IRunVizRecommendationsTrainerResult> {
  constructor(params: IRunVizRecommendationsTrainerParams = {}) {
    super('runVizRecommendationsTrainerTask', params);
  }
}
